<!-- 用户中心的goods的商品组件 -->
<template>
    <div class="lby-goods-item" @click="goodsInfo">
        <div class="lby-other-item"><span>战斗力:</span>{{goods.fightNumber}}</div>
        <div class="lby-other-item"><span>属性值:</span>{{goods.attributeScore?goods.attributeScore:"未知"}}</div>
        <div class="lby-other-item"><span>大区:</span>{{regionName}}</div>
        <div class="lby-other-item"><span>小区:</span>{{serverName}}</div>
        <div class="lby-other-item"><span>价格:</span>{{goods.price}}</div>
    </div>
</template>

<script>

export default {
  name: 'UcGoods',
  props: {
    goods: {
      default: () => {
        return {}
      }
    }
  },
  methods: {
    goodsInfo () {
      this.$router.push({
        path: '/goodsinfo',
        query: {
          goodsId: this.goods.id
        }
      })
    }
  },
  computed: {
    regionName () {
      const regions = this.$store.state.basicdata.regionList
      const rs = regions.find(item => item.id === this.goods.region)
      if (rs == null) {
        return '未知'
      }
      return rs.name
    },
    serverName () {
      const servers = this.$store.state.basicdata.serverList
      const rs = servers.find(item => item.id === this.goods.server)
      if (rs == null) {
        return '未知'
      }
      return rs.serverName
    }
  }
}
</script>

<style scoped lang="less">
.lby-goods-item{
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: 1px solid #409eff;
    box-shadow: 0 0 4px rgb(53, 52, 52);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .lby-other-item{
        width: 120;
        margin-left: 25px;
        font-size: 15px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span{
            font-size: 15px;
            color: black;
            font-weight: bold;
            width: 50px;
        }
    }
}
.lby-goods-item:hover{
    border: 1px solid rgb(253, 5, 5);
    cursor: pointer;
    .lby-fight span{
            color:rgb(253, 8, 8);
    }
}

</style>
